import { z } from 'zod';
import { Timestamp } from 'firebase/firestore';

export interface ChatPresence {
  userId: string;
  userName: string;
  userType: 'customer' | 'admin';
  isOnline: boolean;
  isTyping: boolean;
  lastSeen: Date;
}

// Note: Le schéma n'est plus utilisé avec la nouvelle approche timestamp
export const ChatPresenceSchema = z.object({
  userId: z.string(),
  userName: z.string(),
  userType: z.enum(['customer', 'admin']),
  isOnline: z.boolean(),
  isTyping: z.boolean(),
  lastSeen: z.any().transform((val) => {
    if (val instanceof Timestamp) return val.toDate();
    if (val instanceof Date) return val;
    return new Date();
  }),
});

